import React from "react";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { Formik, Form, FormikHelpers } from "formik";
import { object, string } from "yup";
import AddDobProofMaster, {
  DobProofMasterInitialValues,
} from "./AddDobProofMaster";
import { useNavigate } from "react-router-dom";
import { useAddDobProofMasterMutation } from "src/services/DobProofMasterService";
import { showToast } from "src/utils/toaster/showToast";

const AddDobProofMasterWrapper = () => {
  const navigate = useNavigate();
  const [addDobProofMaster] = useAddDobProofMasterMutation();

  // Form Initial Values
  const initialValues: DobProofMasterInitialValues = {
    name: "",
    documentRequired: true,
    numberOfDocumentsRequired: 1,
    documentLabels: [""],
  };

  // Form Validation Schema
  const validationSchema = object({
    name: string().required("Name is required"),
  });

  // Form Submit Handler
  const handleSubmit = (
    values: DobProofMasterInitialValues,
    { setSubmitting }: FormikHelpers<DobProofMasterInitialValues>
  ) => {
    addDobProofMaster(values).then((res: any) => {
      if (res.error) {
        showToast("error", res?.error?.data?.message);
        setSubmitting(false);
      } else {
        showToast("success", res?.data?.message);
        navigate("/dob-proof-master");
        setSubmitting(false);
      }
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <SideNavLayout>
          <Form className="h-full">
            <AddDobProofMaster formikProps={formikProps} />
          </Form>
        </SideNavLayout>
      )}
    </Formik>
  );
};

export default AddDobProofMasterWrapper;
